import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const NotAssignedSvg = styled.svg`
  height: ${prop('size')}px;
  .a {
    fill: #fff;
    stroke: ${prop('color', colorsOptions.greys['grey-50'])};
  }
`

function NotAssignedIcon({ size, color }) {
  return (
    <NotAssignedSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      viewBox="0 0 11 16.356"
    >
      <g id="ic_40_pin_flat_green" transform="translate(0.5 0.5)">
        <path
          className="a"
          id="Pfad_9"
          data-name="Pfad 9"
          d="M353.091,982.138a4.845,4.845,0,0,0-5,4.674c0,3.378,5,10.326,5,10.326s5-6.947,5-10.326a4.846,4.846,0,0,0-5-4.674"
          transform="translate(-348.091 -982.138)"
          strokeWidth="1"
        />
      </g>
    </NotAssignedSvg>
  )
}

NotAssignedIcon.propTypes = {
  size: number,
  color: string,
}

export default NotAssignedIcon
